// Token-bearing links (/reset-password, /verify-email, /accept-invite) are scrubbed from the
// address bar by an early script in public/index.html before analytics loads; the token is
// parked in sessionStorage under this key and read here.
const key = (path) => `dei_link_token:${path}`;

export const readLinkToken = (path) => {
  const fromUrl = new URLSearchParams(window.location.search).get("token");
  if (fromUrl) return fromUrl;
  try { return sessionStorage.getItem(key(path)) || ""; } catch { return ""; }
};

export const clearLinkToken = (path) => {
  try { sessionStorage.removeItem(key(path)); } catch { /* storage unavailable */ }
};
